import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import FlatPicker from 'flatpickr';
import { formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import { saveFollowup } from "../../follow-up/helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";
import { getUsersCount, getUsersCountV2, getUsersList, getUsersListV2 } from "../../employees/helper/api";
// import config from "../../../config";
import client from "../../../clients";
import _ from "lodash";

let flatpickr;


const ScheduleFollowup = (props) => {
  const [trainersList, setTrainersList] = useState([]);
  const pageSize = 20;
  const [pageCount,setPageCount] = useState(0);
  const [selectedUsers,setSelectedUsers] = useState([]);
  const [total,setTotal] = useState(0);
  var [pageNo,setPageNo] = useState(0)
  const [isLoaderStart,setLoaderStart] = useState(false);
  const [isSelectedUserListOpen, setSelectedUserListOpen] = useState(false);
  const trainerFieldRef = useRef(null);
  const flatpickrRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState(null);
  const [currentElementId, setCurrentElementId] = useState("");
  const isMobile = window.innerWidth < 768;
  const [followup, setFollowup] = useState({
    date: "",
    dateDisplay: "",
    todo: "",
    selectedTrainer: "",
    followupType: "",
    convertibilityType: "",
    membershipType: "",
  });
  const [isSelectTrainer, setSelectTrainer] = useState(false);
  const [convertibilityTypes, setConvertibilityTypes] = useState(["Hot","Warm","Cold"])
  const membershipTypes = ["GymWorkout", "PersonalTraining", "GroupEx", "LybertyMembership"];
  const [isButtonLock, setButtonLock] = useState(false);
  const {user,token} = isAuthenticated();
  const isApiCalled  = useRef(false);
  const [searchKey,setSearchKey] = useState('');
  const [isFollowUpTypeListOpen, setFollowUpTypeListOpen] = useState(false);


  const searchUser = event =>{
    isApiCalled.current = false;
    setSearchKey(event.target.value);
  }

  const GetAllUserCount = async () =>{
    try{
      const params = {
        isAllUser:true,
        branchIDs:[props.gym._id],
        // roles:[5,6,7,10,2]
      }

      if(searchKey) params.q=searchKey;

      const response = await getUsersCountV2(user._id,token,params);
      if(!response.error){
        pageNo = 1;
        setPageNo(pageNo);
        setPageCount(Math.ceil(response.total / pageSize));
        setTotal(response.COUNT);
      }
    }catch(error){
    console.error("GetAllUserCount error:", error);   
  }
    
    
  }

  const GetAllUsers = async (isReload) =>{
    try{
      const params = {
        pageNo,
        pageSize,
        isAllUser:true,
        branchIDs:[props.gym._id],
        // roles:[5,6,7,10,2]
      }

      if(searchKey) params.q=searchKey;

      const response = await getUsersListV2(user._id,token,params);
      if(!response.error){
        setTrainersList(isReload?response:[...trainersList,...response]);
      }
    }catch(error){
    console.error("GetAllUsers error:", error);
    }
  }


  const SaveFollowup = async event =>{
    try{
      await startLoader();
      setButtonLock(true)
      const payload = {
        assigned_to_id:followup.selectedTrainer._id,
        scheduled_type:"Enquiry",
        creation_type:"Manual",
        followable_type: followup.followupType,
        date:followup.date,
        to_do:followup.todo,
        dateString:formatDateTime(followup.date),
        convertibility: followup.convertibilityType.toLowerCase(),
        // enquiryIDs:props.selectedUsers.map(data=>data._id)
      };

     if (
        props.followUpType == "balance-due" ||
        props.followUpType == "membership-renewal"
      ) {
        payload.memberID = props.selectedUsers.memberId;

      } else if (props.followUpType == "member-dashboard") {

        payload.memberID = props.selectedUsers._id;

      } else {

        payload.enquiryIDs = props.selectedUsers.map(data => data._id);

      }

      if(followup.followupType == "Membership Renewal" && followup.membershipType){
        payload.membership_plan_type = followup.membershipType;
      }


      const response = await saveFollowup(user._id,token,payload);

      console.log("dcdsddfdfdfdfdfdff");
      console.log(response);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Followup created successfully"
        });
        props.handleCloseModal();
        if(props.reloadFollowup) props.reloadFollowup();
      }
    }catch(error){
      
    }
    await stopLoader();
    setButtonLock(false)
  }

  const toggleUserListView = () => {
    setSelectedUserListOpen(!isSelectedUserListOpen);
  }

  const removeEnq = event => (index) =>{
    setSelectedUsers(oldstate=>{
      const newState = [...oldstate];
      newState.splice(index,1);

      if(!newState.length) props.handleCloseModal();

      return newState;
    })
  }

  const toggleInputFields = (id) => event => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);

      if(id == "followup-type"){
        setFollowUpTypeListOpen(!isFollowUpTypeListOpen)
      }
      if (id == "trainer" && trainerFieldRef.current) {
        const rect = trainerFieldRef.current.getBoundingClientRect();
        setDropdownPos({
          top: rect.bottom + window.scrollY + 4,
          left: rect.left + window.scrollX,
          width: rect.width
        });
      }
      
  if (id == "followup-date") {
    flatpickrRef.current = FlatPicker("#followup-date", {
      dateFormat: "Y-m-d h:i K",
      enableTime: true,
      time_24hr: false,
      defaultDate: new Date(),
      disableMobile: true,
      onChange: ([date]) => {
        if (date < new Date(new Date().setHours(0, 0, 0, 0))) {
          return alert("Please note, selecting a previous date is not allowed. Kindly choose a current or future date");
        }
        const isoString = date.toISOString();
        const displayString = date.toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: true
        });
        setFollowup(prev => ({ ...prev, date: isoString, dateDisplay: displayString }));
      },
      onClose: () => {
        setCurrentElementId(prev => (prev === "followup-date" ? "" : prev));
      }
    });
    flatpickrRef.current.open();
  }
            
      let element = document.getElementById(id);
      if (element) {
        element.focus();
      }

    }
  }

  const selectTrainer = (role) => {
    setFollowup((prev) => ({
      ...prev,
      selectedTrainer: role
    }));
    setSelectTrainer(false);
    setCurrentElementId("");
  }

  const selectConvertibilityType = (type) => {
    setFollowup((prev) => ({
      ...prev,
      convertibilityType: type
    }));
  }

  const selectMembershipType = (type) => {
    setFollowup((prev) => ({
      ...prev,
      membershipType: type
    }));
    setCurrentElementId("");
  }

  const handleChange = (name, type) => event => {
    
    if(name=="todo"){
      setFollowup(prev => ({
        ...prev,
        todo: event.target.value
      }))
    }

    // value = !value ? event.target.value : value;
    // setFollowup({
    //   ...followup,
    //   [name]: value
    // });
    // checkDataField();
  }



  const handleScroll = async event => {
    const {clientHeight, scrollTop, scrollHeight } = event.target;
    // alert(pageCount, pageNo);
    if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isLoaderStart) {
      pageNo = pageNo + 1;
      setPageNo(pageNo)
      setLoaderStart(true)
      await GetAllUsers();
      setLoaderStart(false)
    }
  }

  const handleSelectDropdownItem = (type, value) => {
    if(type == "followup-type"){
      setFollowup(prev => ({
        ...prev,
        followupType: value
      }))
      setCurrentElementId("");
      setFollowUpTypeListOpen(false)

    }
  }
  
useEffect(() => {
  if (currentElementId !== "followup-date") return;

  const handleOutsideInteraction = (event) => {
    const instance = flatpickrRef.current;
    const calendarEl = instance?.calendarContainer;
    const inputEl = document.getElementById("followup-date");

    const clickedInsideCalendar = calendarEl && calendarEl.contains(event.target);
    const clickedOnInput = inputEl && inputEl.contains(event.target);

    if (!clickedInsideCalendar && !clickedOnInput) {
      instance?.close();          
    }
  };

  
  document.addEventListener("click", handleOutsideInteraction, true);
  document.addEventListener("touchstart", handleOutsideInteraction, true);

  return () => {
    document.removeEventListener("click", handleOutsideInteraction, true);
    document.removeEventListener("touchstart", handleOutsideInteraction, true);
  };
}, [currentElementId]);
  useEffect(async ()=>{
    try{
      await startLoader()
      if(!isApiCalled.current){
        isApiCalled.current = true;
        await GetAllUserCount();
        await GetAllUsers(true);
      }
    }catch(error){

    }

    await stopLoader();
    
  },[props.selectedUsers, props.followUpType, searchKey]);

  useEffect(()=>{
    if(props.selectedUsers){
      console.log(props.selectedUsers)
      setSelectedUsers(props.selectedUsers);
    }

    if(props?.followUpType && props.followUpType == "balance-due"){
      setFollowup(prev => ({
        ...prev,
        followupType: "Balance Due"
      }))
    }

    if(props?.followUpType && props.followUpType == "membership-renewal"){
      setFollowup(prev => ({
        ...prev,
        followupType: "Membership Renewal"
      }))
    }

  },[props.selectedUsers, props.followUpType]);


  useEffect(() => {
    if (trainersList.length > 0) {
      const matchedTrainer = trainersList.find(
        data => data._id.toString() === user?._id?.toString()
      );

      if (matchedTrainer) {
        setFollowup(prev => ({
          ...prev,
          selectedTrainer: matchedTrainer
        }));
      }
    }
  }, [trainersList]);
  
  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item" style={{width: window.innerWidth < 640 ? "100%" : "44%", height: window.innerWidth < 640 ? "100%" : "60%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between m-b-16" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.75 6.62484C10.75 6.50328 10.7983 6.3867 10.8843 6.30074C10.9702 6.21479 11.0868 6.1665 11.2083 6.1665H12.125C12.2466 6.1665 12.3632 6.21479 12.4491 6.30074C12.535 6.3867 12.5833 6.50328 12.5833 6.62484V7.5415C12.5833 7.66306 12.535 7.77964 12.4491 7.8656C12.3632 7.95155 12.2466 7.99984 12.125 7.99984H11.2083C11.0868 7.99984 10.9702 7.95155 10.8843 7.8656C10.7983 7.77964 10.75 7.66306 10.75 7.5415V6.62484Z" fill="#ffffff"/>
                  <path d="M3.87435 0.666504C3.9959 0.666504 4.11249 0.714792 4.19844 0.800746C4.2844 0.886701 4.33268 1.00328 4.33268 1.12484V1.58317H11.666V1.12484C11.666 1.00328 11.7143 0.886701 11.8003 0.800746C11.8862 0.714792 12.0028 0.666504 12.1243 0.666504C12.2459 0.666504 12.3625 0.714792 12.4484 0.800746C12.5344 0.886701 12.5827 1.00328 12.5827 1.12484V1.58317H13.4993C13.9855 1.58317 14.4519 1.77632 14.7957 2.12014C15.1395 2.46396 15.3327 2.93027 15.3327 3.4165V13.4998C15.3327 13.986 15.1395 14.4524 14.7957 14.7962C14.4519 15.14 13.9855 15.3332 13.4993 15.3332H2.49935C2.01312 15.3332 1.54681 15.14 1.20299 14.7962C0.85917 14.4524 0.666016 13.986 0.666016 13.4998V3.4165C0.666016 2.93027 0.85917 2.46396 1.20299 2.12014C1.54681 1.77632 2.01312 1.58317 2.49935 1.58317H3.41602V1.12484C3.41602 1.00328 3.4643 0.886701 3.55026 0.800746C3.63621 0.714792 3.75279 0.666504 3.87435 0.666504ZM1.58268 4.33317V13.4998C1.58268 13.743 1.67926 13.9761 1.85116 14.148C2.02307 14.3199 2.25623 14.4165 2.49935 14.4165H13.4993C13.7425 14.4165 13.9756 14.3199 14.1475 14.148C14.3195 13.9761 14.416 13.743 14.416 13.4998V4.33317H1.58268Z" fill="#ffffff"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white" style={{lineHeight:'18px'}}>Schedule Followup</p>
              </div>
              <div onClick={props.handleCloseModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "82%" : "100%"}}>
          <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "0 12px 60px 12px" : "12px" }}>
            {
              props.followUpType == "balance-due" ? (
                <div className="w-full d-flex p-b-16 m-b-16" style={{borderBottom:"1px dashed #9a9a9a"}}>
                  <div className="d-flex m-r-20">
                  {
                    (props.followup?.user?.length>0) && props.selectedUsers?.user?.[0]?.profileID ?(
                      <img className="flex-item fh-member-profile m-r-12" src={`${client.client.client.config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/auto/auto/70`} />
                    ):(
                      <div className="tr-profile-image fh-member-profile d-flex flex-item m-r-12" style={{width:"46px", height:"46px"}}>
                        <p className='flex-item margin-auto' style={{fontSize:20}}>{`${props.selectedUsers?.userInfo?.name}`.trim()[0]}</p>
                      </div>
                    )
                  }
                  <div className="flex-item m-t-4">
                    <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"18px"}}>{props.selectedUsers?.userInfo?.name}</p>
                    <p className="flex-item m-t-2">+91 {props.selectedUsers?.userInfo?.phone}</p>
                  </div>
                </div>
                <div className="flex-item p-r-20 p-l-20 m-r-20" style={{borderRight:"1px solid #9fb2be", borderLeft:"1px solid #9fb2be"}}>
                  <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Invoice Number</p>
                  <p className="flex-item font-weight-700 color-dark-blue m-t-6" style={{lineHeight:"14px"}}>{props.selectedUsers?.payments?.[0].invoice_number ? props.selectedUsers.payments[0].invoice_number : "--"}</p>
                </div>
                <div className="flex-item p-r-20 m-r-20">
                  <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Balance Due</p>
                  <p className="flex-item font-weight-700 color-red m-t-6" style={{lineHeight:"14px"}}>₹ {props.selectedUsers?.balance_amount ? props.selectedUsers.balance_amount : "--"}</p>
                </div>
                </div>
              ) : props.followUpType == "membership-renewal" ? (
                <div className="w-full d-flex p-b-16 m-b-16" style={{borderBottom:"1px dashed #9a9a9a"}}>
                  <div className="d-flex m-r-20">
                  {
                    (props.followup?.user?.length>0) && props.selectedUsers?.user?.[0]?.profileID ?(
                      <img className="flex-item fh-member-profile m-r-12" src={`${client.config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/auto/auto/70`} />
                    ):(
                      <div className="tr-profile-image fh-member-profile d-flex flex-item m-r-12" style={{width:"46px", height:"46px"}}>
                        <p className='flex-item margin-auto' style={{fontSize:20}}>{`${props.selectedUsers?.userInfo?.name}`.trim()[0]}</p>
                      </div>
                    )
                  }
                  <div className="flex-item m-t-4">
                    <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"18px"}}>{props.selectedUsers?.userInfo?.name}</p>
                    <p className="flex-item m-t-2">+91 {props.selectedUsers?.userInfo?.phone}</p>
                  </div>
                </div>
                <div className="flex-item p-r-20 p-l-20 m-r-20" style={{borderRight:"1px solid #9fb2be", borderLeft:"1px solid #9fb2be"}}>
                  <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Membership Plan</p>
                  <p className="flex-item font-weight-700 color-dark-blue m-t-6" style={{lineHeight:"14px"}}>{props.selectedUsers?.membership_plan?.[0].name ? props.selectedUsers.membership_plan[0].name : "--"}</p>
                </div>
                <div className="flex-item p-r-20 m-r-20">
                  <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Expired On</p>
                  <p className="flex-item font-weight-700 color-red m-t-6" style={{lineHeight:"14px"}}>{props.selectedUsers?.ends_at_string ? props.selectedUsers.ends_at_string : "--"}</p>
                </div>
                </div>
              ) : props.followUpType == "member-dashboard" ? (
                <div className="w-full d-flex p-b-16 m-b-16" style={{borderBottom:"1px dashed #9a9a9a"}}>
                  <div className="d-flex m-r-20">
                    {
                      (props.followup?.user?.length>0) && props.selectedUsers?.user?.[0]?.profileID ?(
                        <img className="flex-item fh-member-profile m-r-12" src={`${client.config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/auto/auto/70`} />
                      ):(
                        <div className="tr-profile-image fh-member-profile d-flex flex-item m-r-12" style={{width:"46px", height:"46px"}}>
                          <p className='flex-item margin-auto' style={{fontSize:20}}>{`${props.selectedUsers?.userInfo?.name}`.trim()[0]}</p>
                        </div>
                      )
                    }
                    <div className="flex-item m-t-4">
                      <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"18px"}}>{props.selectedUsers?.userInfo?.name}</p>
                      <p className="flex-item m-t-2">+91 {props.selectedUsers?.userInfo?.phone}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full p-b-16 m-b-16" style={{borderBottom:"1px dashed #9a9a9a"}}>
                  <div className="d-flex space-between m-t-8">
                    <div className="flex-item d-flex">
                      <p className="flex-item font-weight-700 m-r-12 fs-18 color-dark-blue">Selected User(s)</p>
                      <div className="items-count-container bg-dark-blue">
                        <p className="color-white font-weight-700">{props.selectedUsers.length}</p>
                      </div>
                    </div>
                    <div onClick={toggleUserListView} className="table-action-button d-flex" style={{backgroundColor: isSelectedUserListOpen ? "#E33A34" : "#ffffff"}}>
                      <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isSelectedUserListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isSelectedUserListOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                      </svg>
                    </div>
                  </div>
                  {
                    isSelectedUserListOpen && (
                      <div className="selected-enq-user-list-scroll-container slideTopToBottom m-t-12 bg-white">
                        {
                          selectedUsers.map((data, index) => {
                            return[
                              <div className="d-flex w-full space-between">
                                <div className="d-flex">
                                  {/* <div className="table-item-profile d-flex flex-item">
                                    <img className="flex-item" src={'https://picsum.photos/id/1/200/300'} />
                                  </div> */}
                                  <div className="flex-item m-l-8">
                                    <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{data.userInfo.full_name}</p>
                                    <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{data.userInfo.phone}</p>
                                  </div>
                                </div>
                                <svg onClick={removeEnq(index)} className="flex-item" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.62186 20.5C7.17386 20.5 6.79253 20.3426 6.47786 20.028C6.16319 19.7133 6.00586 19.3323 6.00586 18.885V6.49998H5.00586V5.49998H9.00586V4.72998H15.0059V5.49998H19.0059V6.49998H18.0059V18.885C18.0059 19.345 17.8519 19.7293 17.5439 20.038C17.2359 20.3466 16.8512 20.5006 16.3899 20.5H7.62186ZM17.0059 6.49998H7.00586V18.885C7.00586 19.0643 7.06353 19.2116 7.17886 19.327C7.29419 19.4423 7.44186 19.5 7.62186 19.5H16.3909C16.5442 19.5 16.6852 19.436 16.8139 19.308C16.9425 19.18 17.0065 19.0386 17.0059 18.884V6.49998ZM9.81386 17.5H10.8139V8.49998H9.81386V17.5ZM13.1979 17.5H14.1979V8.49998H13.1979V17.5Z" fill="#FF8686"/>
                                </svg>
                              </div>,
                              selectedUsers.length != index + 1 && (
                                <div className="user-separator m-t-12 m-b-12"/>
                              )
                            ]
                          })
                        }
                      </div>
                    )
                  }
                </div>
              )
            }
            {/* <div onClick={()=>toggleInputFields('followup-type')} className={`${currentElementId == "source" || followup.followupType ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "source" || followup.followupType) ? "1px solid var(--darkBlue)" : "" }}>
              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "source" || followup.followupType) ? "6px" : ""}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "source" || followup.followupType) ? "10px" : "14px", lineHeight: (currentElementId == "source" || followup.followupType) ? "10px" : "14px", color: (currentElementId == "source" || followup.followupType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Source <span className="font-weight-700 color-red">*</span></p>
              </div>
              <input id="source" className={`${(currentElementId == "source" || followup.followupType) ? "active-input-field" : "inactive-input-field"}`}  type="text" placeholder="Select Source" value={followup.followupType ? followup.followupType : ""} style={{ pointerEvents: "none", textTransform: 'capitalize', marginTop:"4px" }} />
            </div> */}
            <div className="d-flex-wrap w-full space-between">
              <div onClick={toggleInputFields('followup-date')} className={`${currentElementId == "followup-date" || followup.date ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "followup-date" || followup.date ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                <div className="flex-item d-flex">
                  <svg className="flex-item m-r-12" width={currentElementId == "followup-date" || followup.date ? "12" : "16"}  height={currentElementId == "followup-date" || followup.date ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "followup-date" || followup.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                    <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "followup-date" || followup.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                  </svg>
                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "followup-date" || followup.date ? "10px" : "14px", color: currentElementId == "followup-date" || followup.date ? "var(--darkBlue)" : "", transition: "180ms" }}>Follow Up Date <span className="font-weight-700 color-red">*</span></p>
                </div>
                <input id="followup-date" value={followup.dateDisplay} placeholder="DD/MM/YYYY" className={`${currentElementId == "followup-date" || followup.date ? "active-input-field" : "inactive-input-field"}`} type="text" />
              </div>
              <div onClick={toggleInputFields('followup-type')} className={`${currentElementId == 'followup-type' || followup.followupType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'followup-type' || followup.followupType ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "100%" : "100%", width: "49%" }}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'followup-type' || followup.followupType ? "10px" : "14px", color: currentElementId == 'followup-type' || followup.followupType ? "var(--darkBlue)" : "", transition: "180ms" }}>Follow-Up Type <span className='color-red'>*</span></p>
                    </div>
                    <input readOnly value={followup.followupType} type="text" className={`${currentElementId == 'followup-type' || followup.followupType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select the type of lead" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isFollowUpTypeListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  {
                    isFollowUpTypeListOpen && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Anniversary Wish")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Anniversary Wish</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Balance Due")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Balance Due</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Birthday Wish")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Birthday Wish</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Commitment")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Commitment</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Enquiry")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Enquiry</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Feedback")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Feedback</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Freeze")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Freeze</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Irregular Member")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Irregular Member</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Membership Renewal")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Membership Renewal</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Measurement")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Measurement</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "P.T. Renewal")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">P.T. Renewal</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Regular Member")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Regular Member</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("followup-type", "Other")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Other</p>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
             <div ref={trainerFieldRef} onClick={toggleInputFields('trainer')} className={`${currentElementId == "trainer" || followup.selectedTrainer ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "trainer" || followup.selectedTrainer) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width: "49%" }}>
                {
                  isMobile ? (
                    <div className='d-flex w-full space-between'>
                      <div className='flex-item'>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-8" width={(currentElementId == "trainer" || followup.selectedTrainer) ? "14" : "20"} height={(currentElementId == "trainer" || followup.selectedTrainer) ? "14" : "20"} style={{ transition: "180ms" }} viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.85 0.750001C4.23073 0.750001 4.60292 0.859964 4.91946 1.066C5.23607 1.27202 5.48275 1.56486 5.62849 1.90747C5.77416 2.25008 5.81231 2.62708 5.73804 2.99079C5.66377 3.35451 5.48037 3.6886 5.21115 3.95083C4.94193 4.21305 4.59893 4.39162 4.22555 4.46397C3.85217 4.53632 3.46508 4.49919 3.11333 4.35728C2.76158 4.21536 2.46094 3.97503 2.24942 3.66669C2.0379 3.35835 1.925 2.99584 1.925 2.625C1.925 2.12772 2.12781 1.6508 2.48882 1.29917C2.84983 0.947541 3.33945 0.750001 3.85 0.750001ZM3.85 0C3.31698 0 2.79593 0.153951 2.35274 0.442393C1.90955 0.730828 1.56412 1.1408 1.36014 1.62046C1.15617 2.10011 1.10279 2.62791 1.20679 3.13711C1.31077 3.64631 1.56745 4.11404 1.94435 4.48116C2.32125 4.84827 2.80146 5.09831 3.32423 5.19953C3.84701 5.30082 4.38886 5.24888 4.88131 5.05015C5.37376 4.8515 5.79467 4.51505 6.09084 4.08337C6.38694 3.65169 6.545 3.14418 6.545 2.625C6.545 1.92881 6.26108 1.26113 5.75568 0.768845C5.25021 0.276563 4.56477 0 3.85 0ZM7.7 10.5H6.93V8.62498C6.93 8.37879 6.88023 8.13498 6.78349 7.90748C6.68675 7.67998 6.54493 7.47327 6.36615 7.29918C6.18744 7.12509 5.9752 6.98698 5.74168 6.89276C5.50809 6.79847 5.25777 6.75003 5.005 6.75003H2.695C2.18446 6.75003 1.69483 6.94757 1.33382 7.29918C0.972811 7.65079 0.77 8.1277 0.77 8.62498V10.5H0V8.62498C0 7.92883 0.283934 7.2611 0.789348 6.76886C1.29475 6.27655 1.98024 5.99998 2.695 5.99998H5.005C5.71977 5.99998 6.40521 6.27655 6.91068 6.76886C7.41608 7.2611 7.7 7.92883 7.7 8.62498V10.5Z" fill={(currentElementId == "trainer" || followup.selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"}/>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "trainer" || followup.selectedTrainer) ? "10px" : "14px", lineHeight: (currentElementId == "trainer" || followup.selectedTrainer) ? "10px" : "14px", color: (currentElementId == "trainer" || followup.selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Assign To <span className="font-weight-700 color-red">*</span></p>
                        </div>

                        <input readOnly id="trainer"
                              value={followup.selectedTrainer ? followup.selectedTrainer.name : ""}
                              type="text"
                              className={`${(currentElementId == "trainer" || followup.selectedTrainer) ? "active-input-field" : "inactive-input-field"}`}
                              placeholder="Select Employee" />
                      </div>

                      <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                        <svg className="flex-item" style={{ transform: currentElementId == "trainer" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex-item d-flex" style={{marginTop: (currentElementId == "trainer" || followup.selectedTrainer) ? "4px" : ""}}>
                        <svg className="flex-item m-r-8" width={(currentElementId == "trainer" || followup.selectedTrainer) ? "14" : "20"} height={(currentElementId == "trainer" || followup.selectedTrainer) ? "14" : "20"} style={{ transition: "180ms" }} viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.85 0.750001C4.23073 0.750001 4.60292 0.859964 4.91946 1.066C5.23607 1.27202 5.48275 1.56486 5.62849 1.90747C5.77416 2.25008 5.81231 2.62708 5.73804 2.99079C5.66377 3.35451 5.48037 3.6886 5.21115 3.95083C4.94193 4.21305 4.59893 4.39162 4.22555 4.46397C3.85217 4.53632 3.46508 4.49919 3.11333 4.35728C2.76158 4.21536 2.46094 3.97503 2.24942 3.66669C2.0379 3.35835 1.925 2.99584 1.925 2.625C1.925 2.12772 2.12781 1.6508 2.48882 1.29917C2.84983 0.947541 3.33945 0.750001 3.85 0.750001ZM3.85 0C3.31698 0 2.79593 0.153951 2.35274 0.442393C1.90955 0.730828 1.56412 1.1408 1.36014 1.62046C1.15617 2.10011 1.10279 2.62791 1.20679 3.13711C1.31077 3.64631 1.56745 4.11404 1.94435 4.48116C2.32125 4.84827 2.80146 5.09831 3.32423 5.19953C3.84701 5.30082 4.38886 5.24888 4.88131 5.05015C5.37376 4.8515 5.79467 4.51505 6.09084 4.08337C6.38694 3.65169 6.545 3.14418 6.545 2.625C6.545 1.92881 6.26108 1.26113 5.75568 0.768845C5.25021 0.276563 4.56477 0 3.85 0ZM7.7 10.5H6.93V8.62498C6.93 8.37879 6.88023 8.13498 6.78349 7.90748C6.68675 7.67998 6.54493 7.47327 6.36615 7.29918C6.18744 7.12509 5.9752 6.98698 5.74168 6.89276C5.50809 6.79847 5.25777 6.75003 5.005 6.75003H2.695C2.18446 6.75003 1.69483 6.94757 1.33382 7.29918C0.972811 7.65079 0.77 8.1277 0.77 8.62498V10.5H0V8.62498C0 7.92883 0.283934 7.2611 0.789348 6.76886C1.29475 6.27655 1.98024 5.99998 2.695 5.99998H5.005C5.71977 5.99998 6.40521 6.27655 6.91068 6.76886C7.41608 7.2611 7.7 7.92883 7.7 8.62498V10.5Z" fill={(currentElementId == "trainer" || followup.selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"}/>
                        </svg>
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "trainer" || followup.selectedTrainer) ? "10px" : "14px", lineHeight: (currentElementId == "trainer" || followup.selectedTrainer) ? "10px" : "14px", color: (currentElementId == "trainer" || followup.selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Assign To <span className="font-weight-700 color-red">*</span></p>
                      </div>
                      <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
                        <svg className="flex-item" style={{ transform: currentElementId == "trainer" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                        </svg>
                      </div>
                      {
                        followup.selectedTrainer ? (
                          <div className="w-full d-flex m-t-7">
                            <div className="flex-item">
                              <p className="font-weight-600" style={{lineHeight:"16px"}}>{followup.selectedTrainer.name}</p>
                            </div>
                          </div>
                        ) : <p id="trainer" className={`flex-item color-grey-04 fs-16 m-t-24 ${(currentElementId == "trainer" || followup.selectedTrainer) ? "active-input-field" : "inactive-input-field"}`}>Select Employee</p>
                      }
                    </>
                  )
                }

                {
                  currentElementId == "trainer" && dropdownPos && ReactDOM.createPortal(
                    <div className="scaleFromTopToBottom no-scroll-bar" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, width: dropdownPos.width, background: "#f5f5f5", border: "1px solid #f5f5f5", borderRadius: "8px", boxShadow: "0px 0px 8px rgba(0,0,0,0.35)", zIndex: 9999999, maxHeight: "260px", overflow: "hidden" }} onClick={e => e.stopPropagation()} >
                      <div className="w-full" style={{ padding: "8px", backgroundColor: "#f5f5f5", position: "sticky", top: 0 }}>
                        <div className="search-container d-flex space-between" style={{ width: "100%", background: "#ffffff" }}>
                          <div className="d-flex w-full">
                            <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <input onChange={_.debounce(searchUser, 400)} type="text" placeholder={`Search Employee by "Name"`} className="flex-item search-input" style={{ width: "85%" }} />
                          </div>
                        </div>
                      </div>
                      <div className="w-full" style={{ padding: "0px 8px 8px 8px", minHeight: '100px', maxHeight: '190px', overflowY: 'auto' }} onScroll={handleScroll}>
                        {
                          trainersList.map((trainer, index) => (
                            <div key={trainer._id || index} onClick={() => selectTrainer(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                              {
                                trainer.profileID ? (
                                  <img className="flex-item table-logo-icon m-r-8" src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${trainer.profileID}?${Date.now()}`} />
                                ) : (
                                  <div className="table-logo-icon m-r-8 flex-item d-flex" style={{ backgroundColor: "#5d883c" }}>
                                    <p className='flex-item' style={{ color: "#ffffff", margin: "0 auto", fontSize: 14 }}>{`${trainer.name}`.trim()[0]}</p>
                                  </div>
                                )
                              }
                              <p className="font-weight-600 fs-16 flex-item" style={{ lineHeight: "16px" }}>{trainer.name}</p>
                            </div>
                          ))
                        }
                        {isLoaderStart && <div className="loader-5 center"><span></span></div>}
                      </div>
                    </div>,
                    document.body
                  )
                }
              </div>
              <div onClick={toggleInputFields('convertibility-type')} className={`${currentElementId == "convertibility-type" || followup.convertibilityType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width: "49%" }}>
                  {
                    isMobile ? (
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "10px" : "14px", lineHeight: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "10px" : "14px", color: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Convertibility Type <span className="font-weight-700 color-red">*</span></p>
                          </div>

                          <input readOnly id="convertibility-type"
                                value={followup.convertibilityType || ""}
                                type="text"
                                className={`${(currentElementId == "convertibility-type" || followup.convertibilityType) ? "active-input-field" : "inactive-input-field"}`}
                                placeholder="Select Convertibility Type" 
                                style={{ marginTop : (currentElementId === "convertibility-type" || followup.convertibilityType) ? "6px" : "" }} />
                        </div>

                        <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" style={{ transform: currentElementId == "convertibility-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>

                        {
                          currentElementId == "convertibility-type" && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                              <div className="w-full">
                                {
                                  convertibilityTypes.map((data, index) => {
                                    return (
                                      <div key={index} onClick={()=>selectConvertibilityType(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        }
                      </div>
                    ) : (
                      <>
                        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "4px" : ""}}>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "10px" : "14px", lineHeight: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "10px" : "14px", color: (currentElementId == "convertibility-type" || followup.convertibilityType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Convertibility Type <span className="font-weight-700 color-red">*</span></p>
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" style={{ transform: currentElementId == "convertibility-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p id="convertibility-type" className={`flex-item fs-16 ${(currentElementId == "convertibility-type" || followup.convertibilityType) ? "active-input-field" : "inactive-input-field"} m-t-24`} style={{color: !followup.convertibilityType && "#6d6d6d"}}>{followup.convertibilityType ? followup.convertibilityType : "Select Convertibility Type"}</p>

                        {
                          currentElementId == "convertibility-type" && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : followup.convertibilityType && "60px"}}>
                              <div className="w-full">
                                {
                                  convertibilityTypes.map((data, index) => {
                                    return (
                                      <div key={index} onClick={()=>selectConvertibilityType(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        }
                      </>
                    )
                  }
                </div>
              {
                followup.followupType == "Membership Renewal" && (
                  <div onClick={toggleInputFields('membership-type')} className={`${currentElementId == "membership-type" || followup.membershipType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "membership-type" || followup.membershipType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width: "49%" }}>
                    <div className="flex-item d-flex" style={{marginTop: (currentElementId == "membership-type" || followup.membershipType) ? "4px" : ""}}>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "membership-type" || followup.membershipType) ? "10px" : "14px", lineHeight: (currentElementId == "membership-type" || followup.membershipType) ? "10px" : "14px", color: (currentElementId == "membership-type" || followup.membershipType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Plan Type <span className="font-weight-700 color-red">*</span></p>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: currentElementId == "membership-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    <p id="membership-type" className={`flex-item fs-16 ${(currentElementId == "membership-type" || followup.membershipType) ? "active-input-field" : "inactive-input-field"} m-t-24`} style={{color: !followup.membershipType && "#6d6d6d"}}>{followup.membershipType ? followup.membershipType : "Select Membership Type"}</p>

                    {
                      currentElementId == "membership-type" && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : followup.membershipType && "60px"}}>
                          <div className="w-full">
                            {
                              membershipTypes.map((type, index) => {
                                return (
                                  <div key={index} onClick={()=>selectMembershipType(type)} className="global-input-field-arrow-dropdown-item d-flex">
                                    <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{type}</p>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div> 
            <div onClick={toggleInputFields('followup-todo')} className={`${(currentElementId == 'followup-todo' || followup.todo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'followup-todo' || followup.todo) ? "1px solid var(--darkBlue)" : "", width: "100%", height:"100px" }}>
              <div className="d-flex m-t-6" style={{alignSelf:"flex-start"}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'followup-todo' || followup.todo) ? "10px" : "14px", color: (currentElementId == 'followup-todo' || followup.todo) ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment <span className='color-red'>*</span></p>
              </div>
              <textarea id="followup-todo" onChange={handleChange("todo")} value={followup.todo} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'followup-todo' || followup.todo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Type Member Follow-Up Comment' />
            </div>
          </div>
          {
            followup.convertibilityType && followup.date && followup.todo && followup.selectedTrainer && followup.followupType &&
            (followup.followupType !== "Membership Renewal" || followup.membershipType) && (
              <div className="bottom-action-button">
                <div onClick={isButtonLock?null:SaveFollowup} className={`member-button-global btn-center  d-flex ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"}`} style={{ width: "100%", height:"40px", borderRadius:"20px" }}>
                  <p className="flex-item">Confirm</p>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default ScheduleFollowup;